import React from "react";
import { Field, reduxForm } from "redux-form";
import validator from 'validator';
import { renderTextField, renderSelectField } from "../helpers/formFields";

import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import MenuItem from '@mui/material/MenuItem';

import { countries } from "../helpers/dataOptions";

class BusinessDetailsForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>

                <Field
                    name="businessname"
                    id="businessname"
                    component={renderTextField}
                    label="Business name"
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="businessnumber"
                    id="businessnumber"
                    component={renderTextField}
                    label="Business registration number"
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="business_email"
                    id="business_email"
                    component={renderTextField}
                    label="Business email address"
                    autoComplete="email"
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field
                    name="country"
                    component={renderSelectField}
                    label="Country"
                    required={true}
                >
                    <MenuItem value="" />
                    {countries.map(country => (
                        <MenuItem value={country.label} key={country.label}>{country.label}</MenuItem>
                    ))}

                </Field>
                <Field
                    name="street"
                    id="street"
                    component={renderTextField}
                    label="Street address"
                    margin="normal"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <Grid container spacing={2}>
                    <Grid item sm={6}>
                        <Field
                            name="postcode"
                            id="postcode"
                            component={renderTextField}
                            label="Postal code"
                            margin="normal"
                            fullWidth
                            required
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <Field
                            name="city"
                            id="city"
                            component={renderTextField}
                            label="City"
                            margin="normal"
                            fullWidth
                            required
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Save
                </Button>
            </form>
        )
    }
}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.businessname) {
        errors.businessname = 'You did not enter a business name';
    }

    if (!formValues.business_email) {
        errors.business_email = 'You must enter a email';
    }

    if (formValues.business_email) {
        if (!validator.isEmail(formValues.business_email)) {
            errors.business_email = 'You must enter a valid email';
        }
    }

    return errors;
};

export default reduxForm({
    form: 'businessDetailsForm',
    validate: validate
})(BusinessDetailsForm);